import { render, staticRenderFns } from "./SbolExportFromJson.vue?vue&type=template&id=f8b9a12e&scoped=true&"
import script from "./SbolExportFromJson.vue?vue&type=script&lang=js&"
export * from "./SbolExportFromJson.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbolExportFromJson.vue?vue&type=style&index=0&id=f8b9a12e&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f8b9a12e",
  null
  ,true
)

export default component.exports